import { Layout } from '@/components/Layout';
import { LookupTable } from '../components/LookupTable';
import { lookupsApi } from '../api';

export default function SizePage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <LookupTable
          title="Tamaños"
          description="Gestiona los tamaños de animales"
          queryKey="size"
          listFn={lookupsApi.listSize}
          createFn={lookupsApi.createSize}
          updateFn={lookupsApi.updateSize}
          deleteFn={lookupsApi.deleteSize}
        />
      </div>
    </Layout>
  );
}
